import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

// Approve / reject with a mandatory note on rejection. `onDecide(decision, note)` performs the call.
export function DecideActions({ onDecide, testPrefix }) {
  const [rejecting, setRejecting] = useState(false);
  const [note, setNote] = useState("");
  return (
    <div className="flex flex-col gap-2">
      <div className="flex gap-2">
        <Button size="sm" className="bg-[#3D8B65] text-white hover:bg-[#2E6B4E]" onClick={() => onDecide("approve")} data-testid={`${testPrefix}-approve`}>Approve</Button>
        <Button size="sm" variant="outline" onClick={() => setRejecting(!rejecting)} data-testid={`${testPrefix}-reject`}>Reject</Button>
      </div>
      {rejecting && (
        <div className="flex gap-2">
          <Input value={note} onChange={(e) => setNote(e.target.value)} placeholder="Why can't it be approved?" className="h-8 text-sm" data-testid={`${testPrefix}-reject-note`} />
          <Button size="sm" disabled={!note.trim()} onClick={() => onDecide("reject", note)} data-testid={`${testPrefix}-reject-send`}>Send</Button>
        </div>
      )}
    </div>
  );
}
